module.exports = __webpack_public_path__ + "img/step2a.19645e00.jpg";